export const POST_AUTH_REDIRECT_KEY = 'shell:post-auth-redirect'

let redirectStarted = false

export function isInternalPath(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) {
    return false
  }

  try {
    return new URL(path, 'https://internal.invalid').origin === 'https://internal.invalid'
  }
  catch {
    return false
  }
}

export function consumePostAuthRedirect(): string | null {
  if (typeof window === 'undefined') {
    return null
  }

  const path = window.sessionStorage.getItem(POST_AUTH_REDIRECT_KEY)
  if (path) {
    window.sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY)
  }

  return path
}

export function redirectToAuthLogin(loginPath = '/auth/login'): void {
  if (typeof window === 'undefined' || redirectStarted) {
    return
  }

  const { pathname, search, hash } = window.location
  if (pathname === loginPath || pathname === '/auth/login' || pathname.endsWith('/auth/callback')) {
    return
  }

  const returnPath = `${pathname}${search}${hash}`
  try {
    if (isInternalPath(returnPath)) {
      window.sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, returnPath)
    }
  }
  catch {
    // Login can still continue when storage is unavailable.
  }

  redirectStarted = true
  window.location.href = loginPath
}
